import React from 'react'
import { Formik, Form } from 'formik'
import {
  InputField,
  InputSelectOptions,
  LoaderButton
} from 'components/molecules'
import PropTypes from 'prop-types'
import {
  consignmentInboundRequestDateInputFields,
  consignmentInboundRequestSelectInputFields,
  consignmentInboundRequestTextInputFields
} from './consignment-inbound-request-filter-form-fieds'

const PER_PAGE = {
  10  : '10',
  25  : '25',
  50  : '50',
  100 : '100'
}

const propTypes = {
  filterValues       : PropTypes.object.isRequired,
  onClickSubmitForm  : PropTypes.func.isRequired,
  onClickReset       : PropTypes.func.isRequired,
  showCustomerFields : PropTypes.bool,
  hiddenColumns      : PropTypes.array
}

const defaultProps = {
  hiddenColumns: []
}

/**
 * Form to filters Consignment::InboundRequest data
 * @param {Object} filterValues - current url filter values
 * @param {Function} onClickSubmitForm - function to submit form
 * @param {Function} onClickReset - function to reset form
 * @param {Array<String>} hiddenColumns - Array of hidden columns name so we can hide unnecessary filter
 */

const ConsignmentInboundRequestFilterForm = ({
  filterValues,
  onClickSubmitForm,
  onClickReset,
  hiddenColumns
}) => (
  <Formik
    initialValues={{
      code                  : filterValues.code || '',
      quantity              : filterValues.quantity || '',
      shipping_method       : filterValues.shipping_method || '',
      status                : filterValues.status || '',
      received_at           : filterValues.received_at || '',
      seller_type           : filterValues.seller_type || '',
      seller_name           : filterValues.seller_name || '',
      seller_code           : filterValues.seller_code || '',
      seller_phone          : filterValues.seller_phone || '',
      seller_email          : filterValues.seller_email || '',
      pickup_vehicle_type   : filterValues.pickup_vehicle_type || '',
      scheduled_at          : filterValues.scheduled_at || '',
      dropoff_location_city : filterValues.dropoff_location_city || '',
      sort_by               : filterValues.sort_by || '',
      sort_dir              : filterValues.sort_dir || '',
      per_page              : filterValues.per_page || 10
    }}
    enableReinitialize={ true }
    onSubmit={ onClickSubmitForm }
  >
    {
      (formikProps) => (
        <Form>
          <div className='d-flex flex-wrap mt-3'>

            {
              consignmentInboundRequestTextInputFields.map((inputField) => {
                if (!hiddenColumns.includes(inputField?.name)) {
                  return (
                    <InputField
                      formGroupClassName={ inputField.className || 'pr-3' }
                      key={ `request-pickup-filter-form-field-${inputField?.name}` }
                      type='text'
                      name={ inputField?.name }
                      label={ inputField?.label }
                      placeholder={ inputField?.placeholder }
                      bsSize={ 'sm' }
                    />
                  )
                }
              })
            }

          </div>

          <div className='d-flex flex-wrap'>
            {
              consignmentInboundRequestDateInputFields.map((inputField) => {
                if (!hiddenColumns.includes(inputField?.name)) {
                  return (
                    <InputField
                      type='date'
                      key={ `request-pickup-filter-form-field-${inputField?.name}` }
                      label={ inputField.label }
                      name={ inputField.name }
                      formGroupClassName='pr-3'
                    />)
                }
              })
            }

          </div>

          <div className='d-flex flex-wrap'>
            {
              consignmentInboundRequestSelectInputFields.map((inputField) => {
                if (!hiddenColumns.includes(inputField?.name)) {
                  return (
                    <InputField
                      key={ `request-pickup-filter-form-field-${inputField?.name}` }
                      type='select'
                      name={ inputField?.name }
                      label={ inputField?.label }
                      bsSize={ 'sm' }
                      formGroupClassName='mr-3'
                    >
                      { inputField.children }
                    </InputField>
                  )
                }
              })
            }
            <InputField
              type='select'
              name='per_page'
              label='Per Page'
              bsSize={ 'sm' }
              formGroupClassName='ml-auto'
            >
              <InputSelectOptions
                options={ PER_PAGE }
              />
            </InputField>
          </div>

          <LoaderButton
            color='primary'
            className='mt-auto'
            type='submit'
            disabled={ formikProps.isSubmitting }
            isLoading={ formikProps.isSubmitting }
            text='Filter'
          />
          <LoaderButton
            color='danger'
            disabled={ formikProps.isSubmitting }
            isLoading={ formikProps.isSubmitting }
            text='Reset'
            onClick={ onClickReset }
          />
        </Form>
      )
    }
  </Formik>
)

ConsignmentInboundRequestFilterForm.propTypes    = propTypes
ConsignmentInboundRequestFilterForm.defaultProps = defaultProps

export default ConsignmentInboundRequestFilterForm
